import React from "react";
import styled from "styled-components";
import MediaQuery from "react-responsive";
import { AppContext } from "../AppProvider";

import Logo from "../Logo/";
import Header from "../Header";
import Footer from "../Footer";
import { ButtonLink, Layout } from "../styled";
import theme from "../styled/theme";

const Wrapper = styled.section`
  text-align: center;
  height: calc(100vh - 5rem);
`;

const Box = styled.div`
  background: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  box-shadow: 0 0 8px rgba(57, 56, 56, 0.35);
  margin: -2rem auto 0;
  max-width: 650px;
  padding: 2rem 0.5rem;
  position: relative;
  top: 15px;

  @media (min-width: 768px) {
    padding: 8rem 0 2rem;
    top: 50%;
    transform: rotate(-5deg) translateY(-35%);
  }
`;

const Title = styled.div`
  font-size: 3.5rem;
  line-height: 3.25rem;
  margin-bottom: 2rem;

  @media (min-width: 768px) {
    font-size: 6rem;
    line-height: 4.75rem;
    margin-bottom: 3rem;
  }
`;

const Alert = styled.div`
  background: ${theme.colors.yellow};
  font-size: 1.5rem;
  padding: 1.5rem 2.5rem 1.5rem 3rem;
  position: relative;
  top: 1.5rem;
  left: 0;
  text-transform: uppercase;

  &::before {
    content: "!";
    color: ${theme.colors.primary};
    font-size: 4.5rem;
    position: absolute;
    left: 25px;
    top: 50%;
    transform: translateY(-50%);
  }

  @media (min-width: 768px) {
    bottom: -5rem;
    width: 83%;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const StyledButton = styled(ButtonLink)`
  font-size: 3rem;
  padding: 1rem 3.5rem;
  margin-top: 30px;
`;

const BranchGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
  margin: 1.5rem 1rem 0;
`;

const BranchCard = styled.button`
  background: ${(p) => (p.active ? theme.colors.primary : "white")};
  border: 2px solid ${theme.colors.primary};
  border-radius: 12px;
  color: ${(p) => (p.active ? "white" : theme.colors.black)};
  cursor: pointer;
  padding: 1rem 1.25rem;
  text-align: left;
  transition: all 0.2s ease-in-out;
  box-shadow: ${(p) => (p.active ? "0 6px 12px rgba(0,0,0,0.15)" : "none")};

  &:hover {
    transform: translateY(-2px);
  }

  h4 {
    margin: 0 0 0.35rem;
    font-size: 1.2rem;
    letter-spacing: 0.01em;
  }

  p {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.35rem;
    color: ${(p) => (p.active ? "white" : theme.colors.grayDark)};
  }
`;

const Home = () => {
  const branches = [
    {
      key: "BAMBAN_NACO",
      name: "BAMBAN NACO",
      note: "Cubriendo Serralles, Miraflores, Piantini, Paraiso, Fernandez, Julieta, El Vergel, Zona Universitaria, Gazcue, Arroyo Hondo, Los Pinos y to’ eso pa’ alláRiba!",
    },
    {
      key: "BAMBAN_BELLA_VISTA",
      name: "BAMBAN BELLA VISTA",
      note: "Cubriendo La Julia, La Feria, El Cacique, Evaristo, Quisqueya, El Millón, Los Prados, San Geronimo, La Castellana, Mirador Norte, Cacicazgos, Honduras y to’ eso pa’ alláBajo!",
    },
  ];

  function setHomeText(context) {
    if(!context) return;
    if(!context.isRestaurantOpen) {
      if(context.account && context.account.closed_text) {
        return context.account.closed_text
      } else {
        return "NUESTRO DELIVERY SE ENCUENTRA CERRADO. LAS ORDENES SE RECIBEN EN HORARIO DE 11:00AM - 09:30PM (debido al toque de queda)"
      }
    } else {
      if(context.account && context.account.open_text) {
        return context.account.open_text
      } else {
        return "BIENVENIDOS AL SERVICIO DE DELIVERY Y TAKEOUT DE BAMBAN SUSHI. POR AHORA ESTA DISPONIBLE ORDENAR ARMANDO TU ROLLO, BOWL Y TEMAKI (CONO), BEBIDAS Y POSTRES DE LA CASA UTILIZANDO ESTA PLATAFORMA. CUANDO SE LE CONTACTE VIA WHATSAPP PODRA ORDENAR TARTAR, NIGUIRI Y SASHIMI."
      }
    }
  }
  return (
    <AppContext.Consumer>
      {(context) => (
        <div>
          <MediaQuery maxDeviceWidth={767}>
            <Header hideCart />
          </MediaQuery>
          <Layout>
            <Wrapper>
              <MediaQuery minDeviceWidth={768}>
                <Logo width="600px" />
              </MediaQuery>
              <Box>
                <Title>
                  ORDENA TU PLATO
                  <br />A TU MANErA!
                </Title>
                {context.appMode !== "restaurant" && (
                  <BranchGrid>
                    {branches.map((branch) => (
                      <BranchCard
                        key={branch.key}
                        active={context.branch === branch.key}
                        onClick={() => context.setBranch(branch.key)}
                      >
                        <h4>{branch.name}</h4>
                        <p>{branch.note}</p>
                      </BranchCard>
                    ))}
                  </BranchGrid>
                )}
                <StyledButton
                  bg="primary"
                  groovy={"groovy"}
                  to={
                    !context.isRestaurantOpen ||
                    (context.appMode !== "restaurant" && !context.branch)
                      ? "/"
                      : context.appMode === "restaurant"
                        ? "/ordenar/"
                        : `/ordenar/?branch=${context.branch}`
                  }
                  disabled={
                    !context.isRestaurantOpen ||
                    (context.appMode !== "restaurant" && !context.branch)
                  }
                >
                  {context.appMode === "restaurant"
                    ? "Empezar"
                    : context.branch
                      ? "Empezar"
                      : "Elige tu sucursal"}
                </StyledButton>

                <Alert>
                  {setHomeText(context)}
                </Alert>
                {/* <Alert>
                  {!context.isRestaurantOpen
                    ? "NUESTRO DELIVERY SE ENCUENTRA CERRADO. LAS ORDENES SE RECIBEN EN HORARIO DE 11:00AM - 09:30PM (debido al toque de queda)"
                    : // ? 'NUESTRO DELIVERY SE ENCUENTRA CERRADO.'
                      "BIENVENIDOS AL SERVICIO DE DELIVERY Y TAKEOUT DE BAMBAN SUSHI. POR AHORA ESTA DISPONIBLE ORDENAR ARMANDO TU ROLLO, BOWL Y TEMAKI (CONO), BEBIDAS Y POSTRES DE LA CASA UTILIZANDO ESTA PLATAFORMA. CUANDO SE LE CONTACTE VIA WHATSAPP PODRA ORDENAR TARTAR, NIGUIRI Y SASHIMI."}
                </Alert> */}
              </Box>
            </Wrapper>
          </Layout>
          <Footer />
        </div>
      )}
    </AppContext.Consumer>
  );
};

export default Home;
